import { UnitType } from "@/types/warehouse"
import { RadioGroupItem } from "@/components/ui/radio-group"
import { Label } from "@/components/ui/label"
import { Badge } from "../ui/badge"
import { cn } from "@/lib/utils"
import { formatMonthlyPriceLabel } from "@/hooks/prices/useUnitTypesShowcasePrices"

export function UnitTypeItem({
  unitType,
  monthlyPrice,
  isPriceLoading = false,
}: {
  unitType: UnitType
  monthlyPrice?: number | null
  isPriceLoading?: boolean
}) {
  const priceLabel =
    monthlyPrice != null
      ? formatMonthlyPriceLabel(monthlyPrice)
      : isPriceLoading
        ? "…"
        : "—"

  return (
    <div>
      <RadioGroupItem id={unitType.code} value={unitType.code} className="peer sr-only absolute" />
      <Label
        htmlFor={unitType.code}
        className={cn(
          "flex flex-col items-start justify-between min-h-[160px] bg-background rounded-[4px] px-4 py-3 border-2 border-transparent cursor-pointer",
          "peer-data-[state=checked]:border-brand peer-data-[state=checked]:bg-card peer-data-[state=checked]:pointer-events-none",
          "peer-data-[state=checked]:[&_[data-slot=badge]]:bg-background",
          "hover:bg-card hover:border-brand hover:[&_[data-slot=badge]]:bg-background",
        )}
      >
        <Badge className="text-[12px] leading-[16px] font-medium text-light-muted bg-white rounded-[2px] px-[4px] py-[2px]">{unitType.name}</Badge>
        <div className="flex flex-col gap-2">
          <span className="text-[32px] leading-[36px] font-semibold text-foreground">{unitType.surface} м²</span>
          <span className="text-[18px] leading-[24px] font-medium text-foreground">{priceLabel}</span>
        </div>
      </Label>
    </div>
  )
}
